import React, { useState, useEffect } from 'react'
import HOCButton from 'web/components/Button';
import { Form, Formik, Field } from 'formik';
import RadioButton from 'web/components/form-elements/RadioButton';
import CheckboxInput from 'web/components/form-elements/CheckboxInput';
import CsvDownloader from 'react-csv-downloader';
import { CheckBoxWrapper } from './PTPlusStyled'

export default function ExportModal(pageProps) {
    const [exportOnlyActiveFlatFee, setExportOnlyActiveFlatFee] = useState(false)
    const [selectOption, setSelectOption] = useState('All')
    const [selectedColumns, setSelectedColumns] = useState([])
    const [csvHeaderArray, setCsvHeaderArray] = useState(pageProps.csvHeaders)
    const [csvData, setCsvData] = useState(pageProps.csvData)

    useEffect(() => {
        setCsvHeaderArray(pageProps.csvHeaders)
        setCsvData(pageProps.csvData)
    }, [])

    const setColumnstoCsvHeaders = selectedColumnsList => {
        let copyCSVHeaders = JSON.parse(JSON.stringify(pageProps.csvHeaders))

        let finalCSVHeaderList = copyCSVHeaders
            .filter(csvHeader => selectedColumnsList.includes(csvHeader.id))
            .sort((a, b) => a.order - b.order)

        setCsvHeaderArray(selectOption === 'All' ? pageProps.csvHeaders : finalCSVHeaderList);
    }


    const selectOptions = [
        { label: 'All Fields', value: 'All' },
        { label: 'Custom Fields', value: 'Custom' }
    ]

    const exportReport = () => {
        pageProps.onEnter()
    }

    const getInitialValues = {
        selectOptions: 'All'
    }
    const VALIDATION_SCHEMA = () => { }

    return (
        <div>
            <Formik
                initialValues={getInitialValues}
                validationSchema={VALIDATION_SCHEMA()}
                onSubmit={(values) => { }}>
                {(props) => {
                    return (
                        <>
                            <Form>
                                <div>
                                    <CheckboxInput
                                        name='Export Only Active Flat Fee Users'
                                        label='Export Only Active Flat Fee Users'
                                        checked={exportOnlyActiveFlatFee}
                                        handleSelect={(val, label, flag) => {
                                            setExportOnlyActiveFlatFee(flag)
                                            if (flag) {
                                                let activeFlatFeeList = pageProps.csvData?.filter(data => JSON.parse(data?.isActiveFlatFee) === 'active')
                                                setCsvData(activeFlatFeeList)
                                            } else {
                                                setCsvData(pageProps.csvData)
                                            }
                                        }}
                                    />
                                </div>
                                <p className="mt-0" style={{ fontWeight: 'bold' }}>Columns</p>
                                <div className="mt-3" style={{ display: 'flex' }}>
                                    {selectOptions.map((value, index) => (
                                        <div key={index} style={{ paddingRight: '25px' }}>
                                            <Field
                                                component={RadioButton}
                                                name='selectOptions'
                                                id={value.value}
                                                defaultValue={selectOptions[0].value}
                                                onSelect={(e) => {
                                                    setSelectOption(e.target.value)
                                                    if (e.target.value === 'All') setCsvHeaderArray(pageProps.csvHeaders)
                                                }}
                                                label={value.label}
                                            />
                                        </div>
                                    ))}
                                </div>
                                {selectOption === 'Custom' &&
                                    <CheckBoxWrapper>
                                        <p className="mt-2" style={{ fontWeight: 'bold' }}>Select Columns</p>
                                        <div className="row">
                                            {pageProps.csvHeaders?.map((value, i) => (
                                                <div className="col-md-4">
                                                    <CheckboxInput
                                                        name={value.displayName}
                                                        label={value.displayName}
                                                        handleSelect={(val, label, flag) => {
                                                            let selectedValue = pageProps.csvHeaders?.filter(val => val.displayName === label)
                                                            let tempValue = selectedColumns
                                                            if (flag && !tempValue.includes(selectedValue[0].id)) tempValue.push(selectedValue[0].id)
                                                            else if (!flag) tempValue = tempValue.filter(val => val !== selectedValue[0].id)
                                                            setSelectedColumns(tempValue)
                                                            setColumnstoCsvHeaders(tempValue)
                                                        }}
                                                    />
                                                </div>
                                            ))}
                                        </div>
                                    </CheckBoxWrapper>
                                }
                                <div style={{ marginTop: '15px', display: 'flex', justifyContent: 'end' }}>
                                    <CsvDownloader
                                        filename="User Details Report"
                                        columns={csvHeaderArray}
                                        datas={csvData}>
                                        <HOCButton
                                            type='app-green-button submitBtn'
                                            handleClick={() => exportReport()}
                                            disabled={selectOption === 'Custom' && selectedColumns.length < 1}>
                                            Export
                                        </HOCButton>
                                    </CsvDownloader>
                                </div>
                            </Form>
                        </>
                    )
                }}
            </Formik>
        </div>
    )
}
